import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment.development';
import { STORAGE_ENUM } from '../../../auth/enums/storage.enum';
import { LocalStorageService } from '../../../shared/services/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SignatureService {
  private _http = inject(HttpClient);
  private _localStorage = inject(LocalStorageService);
  private _baseUrl = `${environment.apiUrl}/administrative`;

  saveSignature(signature: any): Observable<any> {
    const formData = new FormData();

    formData.append('event', signature.event);
    formData.append('signature', signature.signature);
    formData.append('name', signature.name);
    formData.append('job_position', signature.job_position);
    formData.append('comments', signature.comments ?? '');

    return this._http.post<any>(`${this._baseUrl}/mip/signature-forms/`, formData);
  }

  completeEventAfterSignature(eventId: string): Observable<any> {
    const token = this._localStorage.get(STORAGE_ENUM.TOKEN);
    const date = new Date();

    let data = {
      real_final_date: date.toISOString().split('T')[0],
      real_final_hour: date.toTimeString().split(' ')[0],
      real_initial_date: date.toISOString().split('T')[0],
      real_initial_hour: date.toTimeString().split(' ')[0]
    };

    const headers = {
      Authorization: token ? `Bearer ${token}` : ''
    };

    return this._http.patch<any>(
      `${this._baseUrl}/events/09d6a4bc-85ff-4c5b-beb0-8ce5985d394b/completed/`,
      data,
      {
        headers: headers
      }
    );
  }
}
